import React from "react";
import cx from "./cx";

/**
 * Píldora del interruptor. Dos usos:
 *  - decorativa junto a un checkbox real oculto (.rev-switch-input): <RevSwitch on={valor} />
 *    (se pinta aria-hidden; el estado accesible lo lleva el checkbox)
 *  - como control propio: <RevSwitch as="button" role="switch" aria-checked=… onClick=… bare />
 *    `bare` quita borde y padding del botón nativo.
 */
const RevSwitch = ({ as: As = 'span', on, bare, className, ...rest }) => {
    const a11y = As === 'span' ? { 'aria-hidden': 'true' } : { type: 'button' };
    return (
        <As className={cx('rev-switch', bare && 'rev-switch--bare', on && 'rev-switch--on', className)} {...a11y} {...rest}>
            <span className="rev-switch__knob" />
        </As>
    );
};

export default RevSwitch;
